import { render } from "./EditTaxAddressModal.vue?vue&type=template&id=61070b7c&scoped=true"
import script from "./EditTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./EditTaxAddressModal.vue?vue&type=script&lang=js"

import "./EditTaxAddressModal.vue?vue&type=style&index=0&id=61070b7c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61070b7c"]])

export default __exports__